// extracted by mini-css-extract-plugin
export var activityContainer = "_id-0";
export var typingIndicatorContainer = "_id-1";
export var typingIndicatorDot = "_id-2";
export var wave = "_id-3";